module.exports = __webpack_public_path__ + "static/media/브로슈어 썸네일.9a1483d8.png";